import { ViewEntityDialog } from "components/viewDialog/ViewEntityDialog";
import { IViewEntityField } from "components/viewDialog/ViewEntityDialog.types";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useStyles } from "./FeedbackViewModal.styles";
import { IFeedbackViewModalProps } from "./FeedbackViewModal.types";

export const FeedbackViewModal = (
  props: IFeedbackViewModalProps,
): JSX.Element => {
  const styles = useStyles();

  const fields: IViewEntityField[] = [
    { label: "User", value: props.feedback.user?.displayName || "-" },
    {
      label: "Feedback Type",
      value: props.feedback.feedbackType === "like" ? "Positive" : "Negative",
    },
    { label: "User Feedback", value: props.feedback.content || "-" },
    { label: "Prompt", value: props.feedback.prompt || "-" },
    {
      label: "Response",
      value: props.feedback.response ? (
        <div className={styles.responseContainer}>
          <Markdown remarkPlugins={[remarkGfm]}>
            {props.feedback.response}
          </Markdown>
        </div>
      ) : (
        "-"
      ),
    },
    { label: "LLM", value: props.feedback.llm || "-" },
    {
      label: "NHQA Enabled",
      value: props.feedback.nhqaEnabled ? "Yes" : "No",
    },
    {
      label: "Documents Uploaded",
      value: props.feedback.hasFiles ? "Yes" : "No",
    },
  ];

  return (
    <ViewEntityDialog
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      title="Feedback Details"
      fields={fields}
    />
  );
};
